import {formMixin} from "@/utils/FormMixin";
import {formatter as fmt} from "@/utils/form-formatter";
import api from '@/services/api'
import {CONSTANT as constant} from '@/services/constant';
//通用代码api
import {loadBaseCodeData, loadAreaTreeData, dealTreeNoChild} from '@/services/baseCodeSource';
import XEUtils from "xe-utils";
import {validatorPhone, validatorPhoneNoRequire, validatorEmail, validatorEmailNoRequire, jsPrint} from '@/utils/util'
import {getSyncJson, getFormDetail, saveFormDetail} from "@/utils/request";
import {mapState} from "vuex";

export {
	formMixin,
	fmt,
	api,
	constant,
	loadBaseCodeData,
	loadAreaTreeData,
	dealTreeNoChild,
	XEUtils,
	validatorPhone,
	validatorPhoneNoRequire,
	validatorEmail,
	validatorEmailNoRequire,
	jsPrint,
	getSyncJson,
	getFormDetail,
	saveFormDetail,
	mapState
}